import ExpandedPersonalOptions from '@activities/items/ItemActivity/components/ExpandedPersonalOptions';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import Loading from '@components/Loading';
import useItem from '@hooks/item/useItem';
import useShop from '@hooks/shop/useShop';
import useAppCustom from '@hooks/useAppCustom';
import useProject from '@hooks/useProject';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import DefaultOptions from './components/DefaultOptions';
import ItemHeader from './components/ItemHeader';
import ItemInfo from './components/ItemInfo';
import PersonalOptionButton from './components/PersonalOptionButton';
import Recommendation from './components/Recommendation';
import usePrepareOrder from './hooks/usePrepareOrder';
import OrderFooter from '../_shared/components/OrderFooter';

interface Params {
    itemId: string;
    shopId: string;
}

const ItemActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { itemId, shopId } = params;
  const item = useItem(itemId);
  const shop = useShop(shopId);
  const { itemOrderButtonPosition, optionCollapsed } = useAppCustom().item;
  const project = useProject();
  const orderEnabled = project?.features.orderEnabled
      && shop?.shopStatus === 'REGISTERED';
  usePrepareOrder({ itemId, shopId });

  if (item && shop) {
    const { defaultOptionGroups, personalOptionGroups, isSoldOut } = item;
    return (
          <AppScreen >
              <CtaLayout footerPosition={itemOrderButtonPosition}
                         footer={orderEnabled
                           ? <OrderFooter item={item}
                                            shopId={shopId}
                                            isSoldOut={isSoldOut} />
                           : undefined}
                         header={<ItemHeader shopId={shopId}
                                             itemId={itemId} />} >
                  <ItemInfo item={item} shopId={shopId}/>
                  <DefaultOptions itemId={itemId}
                                  optionGroups={defaultOptionGroups} />
                  <Divider/>
                  {(personalOptionGroups.length > 0 && optionCollapsed) && (
                      <Fragment>
                          <PersonalOptionButton itemId={itemId}/>
                          <Divider/>
                      </Fragment>
                  )}
                  {(!optionCollapsed) && (
                      <ExpandedPersonalOptions
                          optionGroups={personalOptionGroups}
                          itemId={itemId} />
                  )}
                  <Recommendation shopId={shopId}
                                  itemId={itemId} />
              </CtaLayout>
          </AppScreen>
    );
  }

  return (
      <AppScreen>
          <Header title='주문하기' />
          <Loading/>
      </AppScreen>
  );
};

export default ItemActivity;
